/**
 * ajax请求配置
 */
// import Vue from 'vue';
import { Message } from 'view-design';
import axios from 'axios';
import store from '@/vuex/store';
import router from '@/router';

// axios默认配置
axios.defaults.timeout = 25000; // 超时时间
// axios.defaults.baseURL 请求地址前缀
// User地址
// axios.defaults.baseURL = '/apis';
// tools地址
axios.defaults.baseURL = 'https://admin.dys360.cn:8091';
// 微服务地址
// axios.defaults.baseURL = 'http://myzuul.com:9527/xdx';

// 整理数据
// axios.defaults.transformRequest = function (data) {
//   data = JSON.stringify(data);
//   return data;
// };

// 路由请求拦截
axios.interceptors.request.use(
  config => {
    // Vue.$indicator.open();
    // 当前路由地址
    // console.log(router.history.current.path)
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';

    let AuthToken = store.state.loginUserInfo.AuthToken;
    if (store.state.loginUserInfo.AuthToken === undefined) {
      AuthToken = '';
    }
    config.headers.common['Authorization'] = AuthToken;
    // config.headers.common['menuId'] = router.history.current.path;
    return config;
  },
  error => {
    return Promise.reject(error);
  });

// 路由响应拦截
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.Error && response.data.Success === false) {
      if (response.data.Error.Code === 401) {
        router.push('/login');
      } else {
        // return response.data;
        Message.error(response.data.Error.Message);
      }
    }
    // Promise.resolve(response);
    return response;
  },
  error => {
    return Promise.reject(error); // 返回接口返回的错误信息
  });
export default axios;



// WEBPACK FOOTER //
// ./src/utils/http.js